import { useState } from 'react';

interface StreamLink {
  label: string;
  url: string;
  icon: string;
}

interface Track {
  title: string;
  spotify?: string;
  appleMusic?: string;
  youtube?: string;
}

interface Album {
  id: number;
  title: string;
  year: string;
  cover: string;
  tracks: Track[];
  streamLinks?: StreamLink[];
}

export default function MusicLibrary() {
  const [expandedAlbum, setExpandedAlbum] = useState<number | null>(null);

  const albums: Album[] = [
    {
      id: 1,
      title: 'Controlled Demolition',
      year: '2025',
      cover: 'https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/5c6acba61b49c0709483bcea89f7db2e.jpeg',
      tracks: [
        { title: 'Not Yours To Take', spotify: 'https://open.spotify.com/track/5GQO1K1ZAxDfygNfs2fFQx?si=6eafda7c0cda4f9b', appleMusic: 'https://music.apple.com/us/song/not-yours-to-take/1841189448', youtube: 'https://music.youtube.com/watch?v=Zuqr3F8H_64&si=gsp73gqO_94h9xFX' },
        { title: 'Cashed Out', spotify: 'https://open.spotify.com/track/1UjpwacYhLSAGEfINSmpeQ?si=ae753c2fac0b45be', appleMusic: 'https://music.apple.com/us/song/cashed-out/1841189450', youtube: 'https://music.youtube.com/watch?v=-DI6wLaI1Zs&si=cQ1hkuG-UMLkO1zs' },
        { title: 'Just Say NO', spotify: 'https://open.spotify.com/track/08ZOhR1D3Qud3yLeNdp4Ol?si=a74d4ee29f3648d4', appleMusic: 'https://music.apple.com/us/song/just-say-no/1841189451', youtube: 'https://music.youtube.com/watch?v=W75GeewqdaA&si=62cpJXL-2wezVsrD' },
        { title: 'WHO Ended Freedom', spotify: 'https://open.spotify.com/track/7I6NmoiqIMvax01xrOAqCj?si=8df717278b634bf3', appleMusic: 'https://music.apple.com/us/song/who-ended-freedom/1841189452', youtube: 'https://music.youtube.com/watch?v=dyriTyXvojk&si=jdAtiRzl0PkvlIpv' },
        { title: "We Don't Count", spotify: 'https://open.spotify.com/track/1kNYipXTileM7nbH8Gl4Ig?si=c9f64edd8ff144ee', appleMusic: 'https://music.apple.com/us/song/we-dont-count/1841189453', youtube: 'https://music.youtube.com/watch?v=lgaoKURV24w&si=xPgBDaccoKhtVrqV' },
        { title: 'Mr.Tariffic', spotify: 'https://open.spotify.com/track/3Rum57m8zUdwf4W31Szox2?si=b20c4166dfa242d3', appleMusic: 'https://music.apple.com/us/song/mr-tariffic/1841189454', youtube: 'https://music.youtube.com/watch?v=Se7TS_hvGcg&si=IyE5tMCLVDaWEMz-' },
        { title: 'Propaganda Machine', spotify: 'https://open.spotify.com/track/3CSeVNNUQXJbQsfAycpdv6?si=9b9b1a7c1a5946a5', appleMusic: 'https://music.apple.com/us/song/propaganda-machine/1841189455', youtube: 'https://music.youtube.com/watch?v=xgzsBmF2mMs&si=Dx4poDJZqUOPmL7t' },
        { title: 'By The Numbers', spotify: 'https://open.spotify.com/track/0UgKdhlLkjdhsECkUnPCYN?si=8d6ade2525c84ec0', appleMusic: 'https://music.apple.com/us/song/by-the-numbers/1841189456', youtube: 'https://music.youtube.com/watch?v=zFMK5seO7AA&si=Ni6QyDDe4e3vbBbv' },
        { title: 'Just Comply (FUCK YOU)', spotify: 'https://open.spotify.com/track/37mrzqdcqVq5twGOhVdr3Y?si=33b5716c4ddc47ad', appleMusic: 'https://music.apple.com/us/song/just-comply-f-k-you/1841189457', youtube: 'https://music.youtube.com/watch?v=RzGWXZy6BHk&si=tUCbBpq7V764y4Nf' },
        { title: 'Boiling Point', spotify: 'https://open.spotify.com/track/2DuhOZVa2EsiIjm2SHbwAr?si=3471b5fe38e14056', appleMusic: 'https://music.apple.com/us/song/boiling-point/1841189878', youtube: 'https://music.youtube.com/watch?v=q1kp8wigwGM&si=hpVUYZT4iZDbYlGI' },
        { title: 'Free Canada', spotify: 'https://open.spotify.com/track/5YmogB8JGd1wg7J2ROZWEb?si=ba5d7abdd5e1465a', appleMusic: 'https://music.apple.com/us/song/free-canada/1841189879', youtube: 'https://music.youtube.com/watch?v=29d7Oxtc0Sg&si=LwGggoKOd70eKgmm' },
      ]
    },
    {
      id: 2,
      title: 'Actors on the Hill (SINGLE)',
      year: '2026',
      cover: 'https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/36f1b7d31c8a4fb7401f3cbad1785fd0.jpeg',
      tracks: [],
      streamLinks: [
        { label: 'Spotify', url: 'https://open.spotify.com/track/63Zz0eVYHYZxfccREmthik?si=02f4127c9a2d48c7', icon: 'ri-spotify-fill' },
        { label: 'Apple Music', url: 'https://music.apple.com/us/album/actors-on-the-hill-single/1865615862', icon: 'ri-apple-fill' },
        { label: 'YouTube', url: 'https://music.youtube.com/watch?v=syccCSmpxwQ&si=ZkXPrqvE9pOSrTIR', icon: 'ri-youtube-fill' },
      ]
    },
    {
      id: 3,
      title: 'Welcome to the "Republic" (SINGLE)',
      year: '2026',
      cover: 'https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/7396cdc3f1f91a79aa81afe08ed12fd8.jpeg',
      tracks: [],
      streamLinks: [
        { label: 'Spotify', url: 'https://open.spotify.com/track/2B8yQ8gknUkmKhczK96nyd?si=dd4846137b70409a', icon: 'ri-spotify-fill' },
        { label: 'Apple Music', url: 'https://music.apple.com/us/song/welcome-to-the-republic/1866385563', icon: 'ri-apple-fill' },
        { label: 'YouTube', url: 'https://music.youtube.com/watch?v=aVQLciOCx8E&si=MPuQ9auf8V7ryt-r', icon: 'ri-youtube-fill' },
      ]
    },
    {
      id: 4,
      title: 'Lines on a Map (SINGLE)',
      year: '2025',
      cover: 'https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/ea0060a441a9668af8c80d4eabdd7a47.jpeg',
      tracks: [],
      streamLinks: [
        { label: 'Spotify', url: 'https://open.spotify.com/album/7tz9XYrjQ2EZdPYvKDmTWy?si=6_K8EB5jRZKHs9fj4LxBjw', icon: 'ri-spotify-fill' },
        { label: 'Apple Music', url: 'https://music.apple.com/us/song/lines-on-a-map/1848040616', icon: 'ri-apple-fill' },
        { label: 'YouTube', url: 'https://music.youtube.com/watch?v=YnToKl47Dk4&si=_38WCTyFRQSOf64x', icon: 'ri-youtube-fill' },
      ]
    }
  ];

  const toggleAlbum = (id: number) => {
    const album = albums.find(a => a.id === id);
    if (album && album.tracks.length === 0) return;
    setExpandedAlbum(expandedAlbum === id ? null : id);
  };

  return (
    <section id="music-library" className="relative py-32 px-6 md:px-12 lg:px-24 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-16">
          <h2 className="text-3xl md:text-4xl font-black tracking-wider text-white uppercase">
            DISCOGRAPHY
          </h2>
          <div className="w-32 h-1 bg-[#ff0033] mt-3"></div>
        </div>

        {/* Albums Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {albums.map((album) => (
            <div
              key={album.id}
              className={`group relative bg-[#0f0f0f] rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-2 ${
                expandedAlbum === album.id ? 'col-span-1 sm:col-span-2' : ''
              } ${album.tracks.length > 0 ? 'cursor-pointer' : 'cursor-default'}`}
              style={{ boxShadow: '0 0 0 rgba(255,0,51,0)' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(255,0,51,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 0 0 rgba(255,0,51,0)';
              }}
              onClick={() => toggleAlbum(album.id)}
            >
              {/* Album Cover */}
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={album.cover}
                  alt={album.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Album Info */}
              <div className="p-5">
                <div className="flex justify-between items-start mb-2">
                  <p className="text-[13px] text-[#4dd0e1] font-semibold">{album.year}</p>
                  {album.tracks.length > 0 && expandedAlbum !== album.id && (
                    <button className="w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-play-circle-line text-white text-2xl"></i>
                    </button>
                  )}
                </div>
                <h3 className="text-lg font-bold text-white mb-3">{album.title}</h3>

                {/* Stream On Buttons for singles */}
                {album.streamLinks && album.streamLinks.length > 0 && (
                  <div className="mt-3 pt-3 border-t border-gray-800">
                    <p className="text-xs text-gray-400 uppercase tracking-wider mb-3">Stream On</p>
                    <div className="flex flex-col gap-2">
                      {album.streamLinks.map((link) => (
                        <a
                          key={link.label}
                          href={link.url}
                          onClick={(e) => e.stopPropagation()}
                          className="flex items-center gap-2 py-2 px-3 bg-white/5 hover:bg-[#ff0033]/20 border border-white/10 hover:border-[#ff0033]/50 text-white text-xs font-semibold rounded-lg transition-all duration-200 whitespace-nowrap"
                        >
                          <span className="w-5 h-5 flex items-center justify-center">
                            <i className={`${link.icon} text-base`}></i>
                          </span>
                          {link.label}
                        </a>
                      ))}
                    </div>
                  </div>
                )}

                {/* Expanded Track List for full albums */}
                {expandedAlbum === album.id && album.tracks.length > 0 && (
                  <div className="mt-4 pt-4 border-t border-gray-800">
                    <p className="text-xs text-gray-400 uppercase tracking-wider mb-3">Tracklist</p>
                    <ul className="space-y-2">
                      {album.tracks.map((track, index) => (
                        <li key={index} className="flex items-center justify-between text-sm text-gray-300 hover:text-white transition-colors group/track">
                          <div className="flex items-center min-w-0">
                            <span className="w-1.5 h-1.5 bg-[#ff0033] mr-3 flex-shrink-0"></span>
                            <span className="text-xs text-gray-500 mr-3 w-6 flex-shrink-0">{String(index + 1).padStart(2, '0')}</span>
                            <span className="truncate text-sm">{track.title}</span>
                          </div>
                          <div className="flex items-center gap-2 ml-3 flex-shrink-0 opacity-60 group-hover/track:opacity-100 transition-opacity">
                            {track.spotify && (
                              <a
                                href={track.spotify}
                                onClick={(e) => e.stopPropagation()}
                                title="Spotify"
                                className="w-6 h-6 flex items-center justify-center text-[#1DB954] hover:scale-110 transition-transform"
                              >
                                <i className="ri-spotify-fill text-base"></i>
                              </a>
                            )}
                            {track.appleMusic && (
                              <a
                                href={track.appleMusic}
                                onClick={(e) => e.stopPropagation()}
                                title="Apple Music"
                                className="w-6 h-6 flex items-center justify-center text-[#fc3c44] hover:scale-110 transition-transform"
                              >
                                <i className="ri-apple-fill text-base"></i>
                              </a>
                            )}
                            {track.youtube && (
                              <a
                                href={track.youtube}
                                onClick={(e) => e.stopPropagation()}
                                title="YouTube"
                                className="w-6 h-6 flex items-center justify-center text-[#FF0000] hover:scale-110 transition-transform"
                              >
                                <i className="ri-youtube-fill text-base"></i>
                              </a>
                            )}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
